const welcome = {
    title: "Bienvenue dans la console d'administration",
    description: "La console d'administration est une application web qui permet de gérer JX Account sans avoir à coder. Commençons par créer un compte. Avec ce compte, vous pouvez gérer JX Account par vous-même ou au nom de votre entreprise.",
    create_account: 'Créer un compte',
};
export default Object.freeze(welcome);
